import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommitteeService } from '../shared/services/committee.service';
import { Subscription } from 'rxjs';
import { ToastService } from '../../../shared/services/toast.service';
import { IApiResponse } from '../../../shared/models/api-response';
import { ICommitteeHistoryDtoWithDescription, ICommitteeHistoryDto, CommitteeUpdateRoleStatus, CommitteeUpdateRoles } from '../../../shared/constants/committee-constants';

@Component({
    selector: 'app-committee-updates',
    templateUrl: './committee-updates.component.html',
    styleUrl: './committee-updates.component.scss',
    standalone: false
})
export class CommitteeUpdatesComponent implements OnInit, OnDestroy {

  loading: boolean = true;
  committees: ICommitteeHistoryDtoWithDescription[] = [];
  viewCommitteesButtonLabel: string = 'View My Committees';
  subscriptions: Subscription = new Subscription();
  constructor(
    private _committeeService: CommitteeService,
    private _toastService: ToastService
  ) {
  }

  ngOnInit(): void {
    this.getCommitteeUpdates();
  }


  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  getCommitteeUpdates() {
    this.subscriptions.add(
      this._committeeService.getCommitteeChangesHistories().subscribe({
        next: (response: IApiResponse<ICommitteeHistoryDto[]>) => {
          let committeeChanges = response.content || [];
          this.committees = committeeChanges?.map(committee => ({
            ...committee,
            description: this.getDescription(committee),
            committeeCode: committee.committee.split(' ')[0] || '',
          }));
          this.loading = false;
        },
        error: (error) => {
          this._toastService.showError(
            'Unable to get the latest committee updates.',
            'Committee Update'
          );
        },
      })
    );
  }


  getDescription(committee: ICommitteeHistoryDto): string {
  const { originalValue, newValue, fullName, committee: committeeName, changeField } = committee;

  if (this.isCommitteeUpdateRoleStatus(changeField)) {
    return `${newValue} is now the ${changeField} for ${committeeName}`;
  } else {
    const isJoinCommittee = (originalValue === null || originalValue === CommitteeUpdateRoleStatus.AwaitingAssignment) &&
                   (newValue === CommitteeUpdateRoleStatus.Current);
    const isLeftCommittee = originalValue === CommitteeUpdateRoleStatus.Current &&
                    (newValue === CommitteeUpdateRoleStatus.Former);

    if (isJoinCommittee) {
      return `${fullName} has joined the committee.`;
    } else if (isLeftCommittee) {
      return `${fullName} has left the committee.`;
    }
  }
  return '';
  }

  isCommitteeUpdateRoleStatus(value: string): Boolean {
    return Object.values(CommitteeUpdateRoles).includes(value as CommitteeUpdateRoles);
  }


}
